import { getValidatedToken } from '@frameio/assets/fields/utils/colorMapping';
import type { SelectOption } from '@frameio/graphql-client/generated';
import { Box, Chip } from '@frameio/vapor';

const MAX_TOKEN_COUNT = 2;

type MultiSelectFieldMatchProps = {
  options: SelectOption[];
  maxTokenCount?: number;
};

export const MultiSelectFieldMatch = ({
  options,
  maxTokenCount = MAX_TOKEN_COUNT,
}: MultiSelectFieldMatchProps) => {
  const collapsedTokenCount = (options?.length ?? 0) - maxTokenCount;

  const tokensToRender =
    collapsedTokenCount > 0 ? options?.slice(0, maxTokenCount) : options;

  return (
    <Box alignItems="center" display="flex" gap={4} height="100%" paddingY={2}>
      {tokensToRender?.map((option) => (
        <Chip
          key={option?.displayName}
          color={getValidatedToken(option?.color ?? '')}
          size="small"
        >
          {option?.displayName}
        </Chip>
      ))}
      {collapsedTokenCount > 0 && (
        <Chip color="default" size="small" style={{ flexShrink: 0 }}>
          +{collapsedTokenCount}
        </Chip>
      )}
    </Box>
  );
};
